import { render, staticRenderFns } from "./TestimonialsSection.vue?vue&type=template&id=4f3d2869&scoped=true"
import script from "./TestimonialsSection.vue?vue&type=script&lang=js"
export * from "./TestimonialsSection.vue?vue&type=script&lang=js"
import style0 from "./TestimonialsSection.vue?vue&type=style&index=0&id=4f3d2869&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3d2869",
  null
  
)

export default component.exports